
import React from "react";

// Collection of hero avatar SVGs suitable for both boys and girls
export const heroAvatars = [
  {
    id: "hero1",
    name: "Captain Shield",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#4361ee" />
        <circle cx="50" cy="50" r="35" fill="#3a0ca3" />
        <path d="M50 15 L60 40 L85 40 L65 55 L75 80 L50 65 L25 80 L35 55 L15 40 L40 40 Z" fill="#f72585" />
        <circle cx="50" cy="50" r="12" fill="#4cc9f0" />
      </svg>
    ),
    gender: "neutral"
  },
  {
    id: "hero2",
    name: "Thunder Girl",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#ff9e00" />
        <path d="M50 15 L55 45 H80 L60 60 L70 90 L50 70 L30 90 L40 60 L20 45 H45 Z" fill="#ff0054" />
        <path d="M45 35 L55 35 L55 60 L60 60 L50 80 L40 60 L45 60 Z" fill="#ffea00" />
      </svg>
    ),
    gender: "female"
  },
  {
    id: "hero3",
    name: "Agent Shadow",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#3f37c9" />
        <circle cx="50" cy="35" r="15" fill="#4895ef" />
        <path d="M25 50 C25 80 75 80 75 50 L75 80 C75 90 25 90 25 80 Z" fill="#4895ef" />
        <path d="M45 35 A5 5 0 0 0 55 35" stroke="#000" fill="none" strokeWidth="2" />
      </svg>
    ),
    gender: "male"
  },
  {
    id: "hero4",
    name: "Cosmic Knight",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#5e60ce" />
        <polygon points="50,15 65,40 90,45 70,65 75,90 50,75 25,90 30,65 10,45 35,40" fill="#5390d9" />
        <circle cx="50" cy="50" r="15" fill="#7400b8" />
        <polygon points="50,40 53,47 60,47 55,52 57,60 50,55 43,60 45,52 40,47 47,47" fill="#80ffdb" />
      </svg>
    ),
    gender: "neutral"
  },
  {
    id: "hero5",
    name: "Nature Guardian",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#2d6a4f" />
        <path d="M50 20 C30 20 20 40 20 50 C20 70 40 80 50 80 C60 80 80 70 80 50 C80 40 70 20 50 20 Z" fill="#40916c" />
        <path d="M35 40 A15 15 0 0 1 65 40 L65 70 A15 15 0 0 1 35 70 Z" fill="#52b788" />
        <circle cx="40" cy="45" r="5" fill="#d8f3dc" />
        <circle cx="60" cy="45" r="5" fill="#d8f3dc" />
      </svg>
    ),
    gender: "female"
  },
  {
    id: "hero6", 
    name: "Tech Wizard",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#003566" />
        <polygon points="50,15 57,35 78,35 61,48 68,68 50,55 32,68 39,48 22,35 43,35" fill="#ffd60a" />
        <circle cx="50" cy="50" r="15" fill="#000814" />
        <path d="M42 50 L58 50 M50 42 L50 58" stroke="#ffc300" strokeWidth="3" />
        <path d="M38 38 L62 62 M38 62 L62 38" stroke="#ffc300" strokeWidth="2" />
      </svg>
    ),
    gender: "male"
  },
  {
    id: "hero7",
    name: "Sky Protector",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#4cc9f0" />
        <path d="M30 70 C30 50 70 50 70 70 L70 85 C70 90 30 90 30 85 Z" fill="#f72585" />
        <path d="M50 15 A20 20 0 0 1 70 35 A20 20 0 0 1 50 55 A20 20 0 0 1 30 35 A20 20 0 0 1 50 15" fill="#f72585" />
        <circle cx="40" cy="35" r="5" fill="white" />
        <circle cx="60" cy="35" r="5" fill="white" />
        <path d="M45 45 A5 5 0 0 0 55 45" stroke="white" fill="none" strokeWidth="2" />
      </svg>
    ),
    gender: "female"
  },
  {
    id: "hero8",
    name: "Galaxy Defender",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#3c096c" />
        <path d="M20 50 A30 30 0 0 1 80 50 A30 30 0 0 1 20 50" fill="#7b2cbf" />
        <path d="M35 30 A15 20 0 0 1 65 30" stroke="#e0aaff" strokeWidth="4" fill="none" />
        <path d="M26 55 A30 30 0 0 0 74 55 L70 80 A20 20 0 0 1 30 80 Z" fill="#5a189a" />
        <circle cx="40" cy="40" r="5" fill="#c77dff" />
        <circle cx="60" cy="40" r="5" fill="#c77dff" />
      </svg>
    ),
    gender: "neutral"
  },
  {
    id: "hero9",
    name: "Flame Warrior",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#d00000" />
        <path d="M50 15 C40 30 25 35 25 55 C25 75 40 85 50 85 C60 85 75 75 75 55 C75 35 60 30 50 15" fill="#e85d04" />
        <path d="M50 25 C45 35 35 40 35 55 C35 70 45 75 50 75 C55 75 65 70 65 55 C65 40 55 35 50 25" fill="#ffba08" />
        <circle cx="40" cy="45" r="5" fill="#dc2f02" />
        <circle cx="60" cy="45" r="5" fill="#dc2f02" />
        <path d="M45 60 A5 5 0 0 0 55 60" stroke="#dc2f02" fill="none" strokeWidth="2" />
      </svg>
    ),
    gender: "male"
  },
  {
    id: "hero10",
    name: "Ninja Shadow",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#212529" />
        <path d="M30 40 L70 40 L70 70 C70 80 30 80 30 70 Z" fill="#495057" />
        <path d="M40 25 L60 25 L65 40 L35 40 Z" fill="#495057" />
        <rect x="35" y="40" width="30" height="5" fill="#212529" />
        <circle cx="40" cy="35" r="3" fill="#f8f9fa" />
        <circle cx="60" cy="35" r="3" fill="#f8f9fa" />
        <path d="M45 70 L55 70 L55 75 L45 75 Z" fill="#212529" />
      </svg>
    ),
    gender: "neutral"
  },
  {
    id: "hero11",
    name: "Magic Princess",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#ff0a54" />
        <path d="M25 85 L35 55 L65 55 L75 85 Z" fill="#ff477e" />
        <path d="M35 55 C35 35 65 35 65 55" fill="#ff477e" />
        <circle cx="50" cy="35" r="15" fill="#ff477e" />
        <path d="M50 15 L53 20 L58 20 L54 25 L56 30 L50 27 L44 30 L46 25 L42 20 L47 20 Z" fill="#ffe5ec" />
        <circle cx="42" cy="33" r="3" fill="#ffe5ec" />
        <circle cx="58" cy="33" r="3" fill="#ffe5ec" />
        <path d="M45 40 A5 5 0 0 0 55 40" stroke="#ffe5ec" fill="none" strokeWidth="2" />
      </svg>
    ),
    gender: "female"
  },
  {
    id: "hero12",
    name: "Robo Friend",
    svg: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="#2b2d42" />
        <rect x="30" y="30" width="40" height="40" rx="5" fill="#8d99ae" />
        <rect x="35" y="40" width="30" height="25" rx="2" fill="#2b2d42" />
        <circle cx="40" cy="50" r="5" fill="#ef233c" />
        <circle cx="60" cy="50" r="5" fill="#ef233c" />
        <rect x="45" y="65" width="10" height="3" fill="#2b2d42" />
        <rect x="40" y="20" width="5" height="10" fill="#8d99ae" />
        <rect x="55" y="20" width="5" height="10" fill="#8d99ae" />
        <rect x="35" y="73" width="10" height="5" rx="2" fill="#8d99ae" />
        <rect x="55" y="73" width="10" height="5" rx="2" fill="#8d99ae" />
      </svg>
    ),
    gender: "neutral"
  }
];

export default heroAvatars;
